import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';

import App from './App';
import * as Sentry from '@sentry/react';
import { redactSensitiveData } from './services/tracking/privacy/redactSensitiveData';

Sentry.init({
  dsn: 'https://03f2a2bdd7ebbba70385ecd01366cecc@o4508184183046144.ingest.de.sentry.io/4509445440798800',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  /**
   * Nothing leaves the browser before it has been through the redaction. An
   * error captured from an API call carries its own request and response with
   * it, so this is the last place the contract on Bearer tokens, Note,
   * motivations, phone numbers and email addresses can still be kept.
   */
  beforeSend: (event) => redactSensitiveData(event),
  beforeSendTransaction: (event) => redactSensitiveData(event),
  /**
   * Breadcrumbs record every request the app made, URL included. A managed lead
   * search is a name, an email or a phone number, so the trail is redacted as
   * it is written rather than when it is sent.
   */
  beforeBreadcrumb: (breadcrumb) => redactSensitiveData(breadcrumb),
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
